<template>
  <div class="app-no-data">
    <div class="app-no-data__icon">
      <app-svg-icon icon-class="no-data" style="width: 86px; height: 86px;"></app-svg-icon>
    </div>
    <div class="app-no-data__tip">暂无文章内容</div>
  </div>
</template>

<script>
export default {
  name: 'AppNoData'
}
</script>

<style lang="scss">
.app-no-data {
  padding: 50px 0;
  text-align: center;

  &__icon,
  &__tip {
    color: #999;
  }
}
</style>
